import { Stepper } from 'src/components/stepper'
import { useTranslation } from 'react-i18next'
import { WizardStep, wizardStepLabelKeys } from 'src/services/statements/wizard'

interface StatementStepIndicatorProps {
  steps: WizardStep[]
  currentStep: WizardStep
  // Steps at or before this index are navigable; later steps are locked until state advances.
  maxNavigableIndex: number
  onStepClick?: (step: WizardStep) => void
}

export function StatementStepIndicator({
  steps,
  currentStep,
  maxNavigableIndex,
  onStepClick,
}: StatementStepIndicatorProps) {
  const { t } = useTranslation()
  const currentIndex = steps.indexOf(currentStep)

  return (
    <Stepper
      aria-label="Statement review steps"
      data-testid="statement-step-indicator"
      currentId={currentStep}
      onStepSelect={onStepClick ? (id) => onStepClick(id as WizardStep) : undefined}
      steps={steps.map((step, i) => ({
        id: step,
        label: t(wizardStepLabelKeys[step]),
        complete: i < currentIndex,
        disabled: i > maxNavigableIndex,
        'data-testid': `step-${step}`,
      }))}
    />
  )
}
